import React, { useContext } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';

import axios from '../../../sharedModules/utils/axios.utils';

import { ChillerLogsContext } from '../contexts/ChillerLogsContext';

const PhotoDeleteConfirmationModal = () => {
  let { photoDeleteConfirmationModalOpen, setPhotoDeleteConfirmationModalOpen, photoToDelete, fetchChillerLogPhotos } =
    useContext(ChillerLogsContext);

  const handleRemoveImage = async () => {
    await axios.delete(`chiller_logs/chiller_log_photos/${photoToDelete?.id}`);
    fetchChillerLogPhotos();
    setPhotoDeleteConfirmationModalOpen(false);
  };

  return (
    <Dialog open={photoDeleteConfirmationModalOpen} onClose={() => setPhotoDeleteConfirmationModalOpen(false)}>
      <Grid container spacing={2} style={{ minWidth: '400px', padding: '30px' }}>
        <Grid item xs={12}>
          <Typography variant="h5">Delete Chiller Log Photo</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6">Are you sure you want to delete this photo?</Typography>
        </Grid>
        <Grid item xs={3}>
          <Button variant="contained" onClick={handleRemoveImage} color="warning">
            Delete
          </Button>
        </Grid>
        <Grid item xs={3}>
          <Button variant="contained" onClick={() => setPhotoDeleteConfirmationModalOpen(false)} color="secondary">
            Cancel
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default PhotoDeleteConfirmationModal;
